import { render, staticRenderFns } from "./AppOrderSuccessSplash.vue?vue&type=template&id=222bede7"
import script from "./AppOrderSuccessSplash.vue?vue&type=script&lang=js"
export * from "./AppOrderSuccessSplash.vue?vue&type=script&lang=js"
import style0 from "./AppOrderSuccessSplash.vue?vue&type=style&index=0&id=222bede7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports